"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[839],{

/***/ 20839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ collection_title; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/home/PlacesSearch/index.jsx + 2 modules
var PlacesSearch = __webpack_require__(69174);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive-modal/dist/react-responsive-modal.esm.js + 3 modules
var react_responsive_modal_esm = __webpack_require__(31190);
;// CONCATENATED MODULE: ./src/components/productcollection/common/model.jsx


function Model(param) {
    var imageUrl = param.imageUrl, label = param.label, fontSize = param.fontSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "outlined model",
        style: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: imageUrl,
                alt: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    fontWeight: 600
                },
                children: label
            })
        ]
    });
}
/* harmony default export */ var model = (Model);

;// CONCATENATED MODULE: ./src/components/productcollection/common/collection-title.jsx





function CollectionTitle(param) {
    var label = param.label, locationRequired = param.locationRequired, geolocation = param.geolocation, imageUrl = param.imageUrl, isUpdating = param.isUpdating, first_name = param.first_name, isAvailable = param.isAvailable;
    var ref = (0,react.useState)(false), showAddressModal = ref[0], setShowAddressModal = ref[1];
    var formattedAddress = (geolocation === null || geolocation === void 0 ? void 0 : geolocation.formattedAddress) || (geolocation === null || geolocation === void 0 ? void 0 : geolocation.formatted_address);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacesSearch/* default */.Z, {
                modalOnly: true,
                isModalOpen: showAddressModal
            }),
            !isUpdating ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "collection-title",
                        children: [
                            isAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "info success",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-check-circle",
                                        "aria-hidden": "true"
                                    }),
                                    first_name ? "Hi, ".concat(first_name) : "Products Available",
                                    " "
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "info error",
                                children: [
                                    "Products",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "info helper",
                                children: first_name ? " items for " : "for your "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(model, {
                                imageUrl: imageUrl ? imageUrl : "",
                                label: label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: " "
                            }),
                            !locationRequired && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "outlined location",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-weight-normal",
                                        children: "Near "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mr-2",
                                        children: formattedAddress === null || formattedAddress === void 0 ? void 0 : formattedAddress.replace(/,[^,]+$/, "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn",
                                        onClick: function() {
                                            return setShowAddressModal(true);
                                        },
                                        children: "(Change)"
                                    })
                                ]
                            })
                        ]
                    }),
                    locationRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                width: "300px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "Update Your Location - Required"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "collection-title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "info success",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-cog fa-spin",
                            "aria-hidden": "true"
                        }),
                        " Loading Locations. Please Wait..."
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var collection_title = (CollectionTitle);


/***/ })

}]);